// extracted by mini-css-extract-plugin
module.exports = {"contenedor":"styles_contenedor__6I30h"};